import html2canvas from 'html2canvas';

export const htmlToDataURL = async (target) => {
  const canvas = await html2canvas(target, {
    backgroundColor: null, // 배경 투명
    scale: 2, // 캔버스 스케일을 높여 품질 개선
  });
  const url = canvas.toDataURL('image/png');

  return url;
};
